import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { getUrlParams } from '~/utils'

export function useQueryParamsPersistence() {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const queryParams = getUrlParams(location.search)
    const queryParamsToEntries = Object.entries(queryParams)

    const queryParamsFiltered =
      queryParamsToEntries.length > 0 ? queryParamsToEntries.filter(([key]) => key !== 'q') : []

    if (queryParamsFiltered.length > 0) {
      sessionStorage.setItem(
        'gfnd.session.query',
        JSON.stringify(Object.fromEntries(queryParamsFiltered))
      )
    }
  }, [history, location])
}

export function useInjectQueryParamsFromStorage() {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const rawStorage = sessionStorage.getItem('gfnd.session.query')

    if (!rawStorage) return

    const storageParams = JSON.parse(rawStorage)
    const currentParams = new URLSearchParams(location.search)

    let shouldReplaceQueryParams = false

    for (const [qKey, qValue] of Object.entries(storageParams)) {
      if (!currentParams.has(qKey)) {
        currentParams.set(qKey, qValue)
        shouldReplaceQueryParams = true
      }
    }

    if (shouldReplaceQueryParams) {
      history.replace({
        pathname: location.pathname,
        search: currentParams.toString()
      })
    }
  }, [history, location])
}
